module.exports = __webpack_public_path__ + "img/althero.a41c7fe3.png";